import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthorization } from '../../hooks/useAuthorization';
import { useAuth } from '../../contexts/AuthContext';
import type { Role } from '../../hooks/useAuthorization';

interface WithRoleAccessProps {
  requiredRoles: Role | Role[];
}

export const withRoleAccess = (requiredRoles: Role | Role[]) => 
  <P extends object>(WrappedComponent: React.ComponentType<P>) => {
    return function WithRoleAccessComponent(props: P) {
      const { user, loading } = useAuth();
      const { hasRole } = useAuthorization();

      if (loading) {
        return <div>Loading...</div>;
      }

      if (!user) {
        return <Navigate to="/login" replace />;
      }

      if (!hasRole(requiredRoles)) {
        return <Navigate to="/unauthorized" replace />;
      }

      return <WrappedComponent {...props} />;
    };
  }; 